import siFetch from "api/fetch";

const detail = (init = null) => siFetch("/api/v1/users/me", init);

export default detail;
